var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:(_vm.getTitle),expression:"getTitle",modifiers:{"left":true}}],class:_vm.getClass})}
var staticRenderFns = []

export { render, staticRenderFns }